<!-- Security - OpenId options -->
<form #openIdForm="ngForm" class="form mt-20">
    <div class="security-category">
      <h5>{{locale.LABEL_IDENTITY_PROVIDER_INFO}}</h5>
      <!-- Provider Id -->
      <div class="form-group app-composite-widget clearfix">
        <label class="control-label app-label col-xs-3 required"
          for="wm-security-openid-providerid">{{locale.LABEL_PROVIDER_ID}}: </label>

        <div class="col-xs-9">
          <select name="wm-security-openid-providerid" id="wm-security-openid-providerid" class="form-control app-select"
            [(ngModel)]="securityService.openId._selectModel" (change)="updateOpenIdOptions(securityService.openId._selectModel)" [disabled]="securityService.isOpenIdProviderDisabled">
            <ng-container *ngFor="let item of securityService.providers">
              <option  [value]="item.providerId" *ngIf="isProviderIdDisabled(item.providerId)">{{item.providerId}}</option>
            </ng-container>
          </select>
          <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.LABEL_HELP_OPENID_PROVIDER_ID}}"
            class="wm-icon wms wms-help ml-5"></i>
          <input name="wm-security-openid-providerid-custom" placeholder="{{locale.PLACEHOLDER_ENTER_PROVIDER_ID}}"
            *ngIf="securityService.openId._selectModel === 'custom'" type="text" class="form-control app-textbox custom-input ml-5"
            [(ngModel)]="security.providerId" (change)="securityService.changeRedirectUrlURL()" />
        </div>
      </div>
      <!-- Authorization URL -->
      <div class="form-group app-composite-widget clearfix">
        <label class="control-label app-label col-xs-3 required"
          for="wm-security-openid-authorization-url">{{locale.LABEL_AUTHORIZATION_URL}}: </label>

        <div class="col-xs-9">
          <input name="wm-security-openid-authorization-url" id="wm-security-openid-authorization-url" placeholder="{{locale.PLACEHOLDER_AUTHORIZATION_URL}}"
            type="text" class="form-control app-textbox wm-security-url" [(ngModel)]="security.authorizationUrl"
            [ngModelOptions]="{'updateOn' : 'blur'}" />
          <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.LABEL_HELP_OPENID_AUTHORIZATION_URL}}"
            class="wm-icon wms wms-help ml-5"></i>
        </div>
      </div>
      <!-- Token URL -->
      <div class="form-group app-composite-widget clearfix">
        <label class="control-label app-label col-xs-3 required"
          for="wm-security-openid-token-url">{{locale.LABEL_TOKEN_URL}}: </label>

        <div class="col-xs-9">
          <input name="wm-security-openid-token-url" id="wm-security-openid-token-url" placeholder="{{locale.PLACEHOLDER_TOKEN_URL}}" type="text"
            class="form-control app-textbox wm-security-url" [(ngModel)]="security.tokenUrl"
            [ngModelOptions]="{'updateOn' : 'blur'}" />
          <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.LABEL_HELP_OPENID_TOKEN_URL}}"
            class="wm-icon wms wms-help ml-5"></i>
        </div>
      </div>
      <!-- JWKS URL -->
      <div class="form-group app-composite-widget clearfix">
        <label class="control-label app-label col-xs-3 required"
          for="wm-security-openid-jwks-url">{{locale.LABEL_JWKS_URL}}: </label>

        <div class="col-xs-9">
          <input name="wm-security-openid-jwks-url" id="wm-security-openid-jwks-url" placeholder="{{locale.PLACEHOLDER_JWKS_URL}}" type="text"
            class="form-control app-textbox wm-security-url" [(ngModel)]="security.jwkSetUrl"
            [ngModelOptions]="{'updateOn' : 'blur'}" />
          <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.LABEL_HELP_OPENID_JWKS_URL}}"
            class="wm-icon wms wms-help ml-5"></i>
        </div>
      </div>
      <!-- User Info Endpoint -->
      <div class="form-group app-composite-widget clearfix">
        <label class="control-label app-label col-xs-3 required"
          for="wm-security-openid-user-endpoint">{{locale.LABEL_USER_INFO_ENDPOINT}}: </label>

        <div class="col-xs-9">
          <input name="wm-security-openid-user-endpoint" id="wm-security-openid-user-endpoint" placeholder="{{locale.PLACEHOLDER_USER_INFO_ENDPOINT}}"
            type="text" class="form-control app-textbox wm-security-url" [(ngModel)]="security.userInfoUrl"
            [ngModelOptions]="{'updateOn' : 'blur'}" />
          <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.LABEL_HELP_OPENID_USER_INFO_ENDPOINT}}"
            class="wm-icon wms wms-help ml-5"></i>
        </div>
      </div>
      <!-- Logout URL -->
      <div class="form-group app-composite-widget clearfix">
        <label class="control-label app-label col-xs-3" for="wm-security-openid-logout-url">{{locale.LABEL_LOGOUT_URL}}:
        </label>

        <div class="col-xs-9">
          <input name="wm-security-openid-logout-url" id="wm-security-openid-logout-url" placeholder="{{locale.PLACEHOLDER_LOGOUT_URL}}" type="text"
            class="form-control app-textbox wm-security-url" [(ngModel)]="security.logoutUrl"
            [ngModelOptions]="{'updateOn' : 'blur'}" />
          <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.LABEL_HELP_OPENID_LOGOUT_URL}}"
            class="wm-icon wms wms-help ml-5"></i>
        </div>
      </div>
      <hr>
    </div>

    <div class="security-category">
      <h5>{{locale.LABEL_SERVICE_PROVIDER_INFO}}</h5>
      <!-- Redirect url -->
      <div class="form-group app-composite-widget clearfix">
        <label class="control-label app-label col-xs-3"
          for="wm-security-openid-redirect-url">{{locale.LABEL_REDIRECT_URL}}: </label>
        <div class="col-xs-9">
          <div class="input-group wm-security-clipboard wm-security-url">
            <input name="wm-security-openid-redirect-url" type="text"
              class="form-control form-input-disabled clipboard-target" [(ngModel)]="security.redirectUrlTemplate"
              readonly />
            <span class="clipboard-button" (click)="copyToClipboard($event)">
              <i title={{locale.ICONTITLE_COPY_CLIPBOARD}} class="wm-icon wms wms-content-copy"></i>
            </span>
          </div>
          <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.LABEL_HELP_OPENID_REDIRECT_URL}}"
            class="wm-icon wms wms-help ml-5"></i>
        </div>
      </div>
      <hr>
    </div>

    <div class="security-category">
      <h5>{{locale.LABEL_INTEGRATION_INFO}}</h5>
      <!-- Client Id -->
      <div class="form-group app-composite-widget clearfix">
        <label class="control-label app-label col-xs-3 required"
          for="wm-security-openid-redirect-url">{{locale.LABEL_CLIENT_ID}}: </label>
        <div class="col-xs-9">
          <input name="wm-security-openid-client-id" id="wm-security-openid-redirect-url" placeholder="{{locale.PLACEHOLDER_CLIENT_ID}}" type="text"
            class="form-control app-textbox wm-security-url" [(ngModel)]="security.clientId"
            [ngModelOptions]="{'updateOn' : 'blur'}" />
          <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.LABEL_HELP_OPENID_CLIENT_ID}}"
            class="wm-icon wms wms-help ml-5"></i>
        </div>
      </div>
      <!-- Client Secret -->
      <div class="form-group app-composite-widget clearfix">
        <label class="control-label app-label col-xs-3 required"
          for="wm-security-openid-client-secret">{{locale.LABEL_CLIENT_SECRET}}: </label>

        <div class="col-xs-9">
          <input name="wm-security-openid-client-secret" id="wm-security-openid-client-secret" placeholder="{{locale.PLACEHOLDER_CLIENT_SECRET}}" type="text"
            class="form-control app-textbox wm-security-url" [(ngModel)]="security.clientSecret"
            [ngModelOptions]="{'updateOn' : 'blur'}" />
          <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.LABEL_HELP_OPENID_CLIENT_SECRET}}"
            class="wm-icon wms wms-help ml-5"></i>
        </div>
      </div>
      <!-- Scope -->
      <div class="form-group app-composite-widget clearfix">
        <label class="control-label app-label col-xs-3 required" for="wm-security-openid-scope">{{locale.LABEL_SCOPES}}: </label>

        <div class="col-xs-9">
          <input name="wm-security-openid-scope" id="wm-security-openid-scope" type="text" placeholder="{{locale.PLACEHOLDER_SCOPES}}"
            class="form-control app-textbox wm-security-url" [(ngModel)]="security.scopes"
            [ngModelOptions]="{'updateOn' : 'blur'}" />
          <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.LABEL_HELP_OPENID_SCOPES}}"
            class="wm-icon wms wms-help ml-5"></i>
        </div>
      </div>
      <!-- User Name Attribute Name -->
      <div class="form-group app-composite-widget clearfix">
        <label class="control-label app-label col-xs-3"
          for="wm-security-openid-user-name">{{locale.LABEL_USER_NAME_ATTRIBUTE}}: </label>

        <div class="col-xs-9">
          <input name="wm-security-openid-user-name" id="wm-security-openid-user-name" type="text"
            placeholder="{{locale.PLACEHOLDER_USER_ID_ATTRIBUTE_NAME}}" class="form-control app-textbox wm-security-url"
            [(ngModel)]="security.userNameAttributeName" [ngModelOptions]="{'updateOn' : 'blur'}" />
          <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.LABEL_HELP_OPENID_USER_NAME_ATTRIBUTE}}"
            class="wm-icon wms wms-help ml-5"></i>
        </div>
      </div>
      <hr>
    </div>

    <div class="security-category">
      <h5>{{locale.LABEL_ROLE}}</h5>

      <!-- Enable Role Mapping-->
      <div class="form-group app-composite-widget clearfix">
        <label class="control-label app-label col-xs-3">{{locale.LABEL_SEARCH_USER_ROLE}}: </label>
        <div class="col-xs-9">
          <wms-toggle id="wm-security-saml-user-roles-toggle-openid" class="metadata-switch switch"
            name="wm-role-config" [model]="security.roleMappingEnabled" [onLabel]="'On'" [offLabel]="'Off'"
            (onChange)="security.roleMappingEnabled = $event;"></wms-toggle>
        </div>
      </div>

      <!-- Search User Role Options-->
      <div *ngIf="security.roleMappingEnabled">
        <div class="form-group app-composite-widget clearfix">
          <label class="control-label app-label col-xs-3"
            for="wm-sec-openid-select-search-user-role-provider">{{locale.LABEL_SELECT_USER_ROLE_PROVIDER}}: </label>
          <div class="col-xs-9">
            <select name="wm-sec-openid-select-search-user-role-provider" id="wm-sec-openid-select-search-user-role-provider" class="form-control app-select"
              [(ngModel)]="security.roleProvider">
              <option *ngFor="let option of security.openIdRoleProviders"  [ngValue]="option.id">{{option.value}}</option>
            </select>
            <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.LABEL_HELP_OPENID_ROLE_PROVIDER}}"
              class="wm-icon wms wms-help ml-5"></i>
          </div>
        </div>
        <div [ngSwitch]="security.roleProvider">
          <div *ngSwitchCase="'OPENID'">
            <div class="form-group app-composite-widget clearfix">
              <label class="control-label app-label col-xs-3 required"
                for="wm-sec-openid-grp-search-base">{{locale.LABEL_ROLE_ATTRIBUTE}}: </label>
              <div class="col-xs-9">
                <input name="wm-sec-openid-grp-search-base" id="wm-sec-openid-grp-search-base" type="text" class="form-control app-textbox"
                  [(ngModel)]="security.roleAttributeName" [ngModelOptions]="{'updateOn' : 'blur'}" />
                <i placement="right" [tooltipAppendToBody]="true"
                  tooltip="{{locale.LABEL_HELP_SAML_ROLE_ATTRIBUTE_NAME}}" class="wm-icon wms wms-help ml-5"></i>
              </div>
            </div>
          </div>
          <div *ngSwitchCase="'DATABASE'" class="security-sub-category">
            <!-- Roles By SQL Query -->
            <wms-database [securityProps]="securityProps" [authInfo]="authInfo"></wms-database>
          </div>
        </div>
      </div>
    </div>
</form>
